export const translateOptions = (options, t) =>
  options.map(({ tKey, ...rest }) => ({ ...rest, label: t(tKey) }))

export const translateColumns = (columns, t) =>
  columns.map(({ tKey, ...rest }) => ({ ...rest, label: t(tKey) }))

export const translateSidebarItems = (items, t) =>
  items.map(({ tKey, links, ...item }) => ({
    ...item,
    title: t(tKey),
    links: links.map(
      ({ tKey: linkTKey, ...link }) => linkTKey ? { ...link, title: t(linkTKey) } : link
    ),
  }))
